<div class="camera-lifetime">
  <mat-card>
    <mat-card-title class="camera-lifetime__title">Lifetime Preview</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="camera-lifetime__content">
      @if (lengthOfRule >= 2) {
        <div class="camera-lifetime__empty">This calculation is only for the first rule!</div>
      }
      @if (lifeTime) {
        <div>
          <div class="camera-lifetime__item">
            <div class="camera-lifetime__item-title">max. lifetime acc. Battery [day]</div>
            <div class="camera-lifetime__item-value">{{ lifeTime?.batteryDays }}</div>
          </div>
          <div class="camera-lifetime__item">
            <div class="camera-lifetime__item-title">max. lifetime acc. SD card [day]</div>
            <div class="camera-lifetime__item-value">{{ lifeTime?.sdDays }}</div>
          </div>
          <div class="camera-lifetime__item">
            <div class="camera-lifetime__item-title">max. lifetime [day]</div>
            <div class="camera-lifetime__item-value">{{ lifeTime?.days }}</div>
          </div>
          <div class="camera-lifetime__item">
            <div class="camera-lifetime__item-title">max. count acc. Battery capacity</div>
            <div class="camera-lifetime__item-value">{{ lifeTime?.batteryCount }}</div>
          </div>
          <div class="camera-lifetime__item">
            <div class="camera-lifetime__item-title">max. count on SD card</div>
            <div class="camera-lifetime__item-value">{{ lifeTime?.sdCount }}</div>
          </div>
          <div class="camera-lifetime__item">
            <div class="camera-lifetime__item-title">max. Count</div>
            <div class="camera-lifetime__item-value">{{ lifeTime?.count }}</div>
          </div>
          <div class="camera-lifetime__item">
            <div class="camera-lifetime__item-title">available end date</div>
            <div class="camera-lifetime__item-value">
              {{ lifeTime?.date | date: 'yyyy-MM-dd' }}
            </div>
          </div>
        </div>
      } @else {
        <div class="camera-lifetime__empty">NO LIFETIME PREVIEW AVAILABLE FOR SELECTED FIELDS</div>
      }
      <ng-template #empty>
        <div class="camera-lifetime__empty">NO LIFETIME PREVIEW AVAILABLE FOR SELECTED FIELDS</div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>
